import React, { useState, useEffect, useRef } from 'react';
import {
    Link,
} from "react-router-dom";
import axios from 'axios';
import dayjs from "dayjs";
import Calendar from '../../../components/calendar/Calendar.js';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminReferenceYear(props) {
    const formRef = useRef(null)

    const [reportdate_filter, setReportdate_filter] = useState(dayjs(new Date()));
    const [datalist, setDatalist] = useState([]);
    const [dataitem, setDataitem] = useState({
        datetimestamp: dayjs(new Date()).format('YYYY-MM-DD 00:00:00'),
        year: 0,
        site_code: 'P3-01',
        site_name: '',
        none_purchase: 0,
        none_purchase_approve: 0,
        disable: false,
    });

    const [mode, setMode] = useState('');
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const [modal_item, setModal_item] = useState(false);
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    const onCalendaraChange_Filter = (date, dateString) => {
        setReportdate_filter(date)
    };

    useEffect(() => {
        api_load()
    }, [reportdate_filter]);

    function init_item() {
        setDataitem({
            datetimestamp: dayjs(new Date()).format('YYYY-MM-DD 00:00:00'),
            year: 0,
            site_code: 'P3-01',
            none_purchase: 0,
            none_purchase_approve: 0,
            disable: false,
        })
    }

    useEffect(() => {
        return () => {
            setDatalist([])
            setDataitem({})
        };
    }, []);

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    async function api_load() {
        setmodal_load({ enable: true, message: "Loading none purchase list." })
        await sleep(500)

        const formData = new FormData()
        formData.append('year', dayjs(reportdate_filter).format('YYYY'))
        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/reference/refpurchase/getlist", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {

                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.yearref !== null && response.data.yearref !== undefined) {
                    setDatalist(response.data.yearref)
                } else {
                    setDatalist([])
                }
            })
            .catch((err) => {
                setDatalist([])
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_add() {
        var formelement = formRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            formelement.classList.remove("was-validated");

            setmodal_load({ enable: true, message: "Adding none purchase to a database." })
            await sleep(500)

            const formData = new FormData();
            formData.append('datetimestamp', dayjs(new Date(dataitem.datetimestamp)).format('YYYY'))
            formData.append('site_code', dataitem.site_code)
            formData.append('none_purchase', dataitem.none_purchase)
            formData.append('none_purchase_approve', dataitem.none_purchase_approve)
            axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/reference/refpurchase/add", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_item(false)
                    init_item()
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your none purchase has been added to a database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        });
                    }
                    if (response.data.yearref !== null && response.data.yearref !== undefined) {
                        setDatalist(response.data.yearref)
                    } else {
                        setDatalist([])
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    });
                });
        }
    }

    async function api_edit() {
        var formelement = formRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            formelement.classList.remove("was-validated");

            setmodal_load({ enable: true, message: "Editing none purchase in a database." })
            await sleep(500)

            const formData = new FormData();
            formData.append('datetimestamp', dayjs(new Date(dataitem.datetimestamp)).format('YYYY'))
            formData.append('site_code', dataitem.site_code)
            formData.append('none_purchase', dataitem.none_purchase)
            formData.append('none_purchase_approve', dataitem.none_purchase_approve)
            axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/reference/refpurchase/edit", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_item(false)
                    init_item()
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your none purchase has been edited in a database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        });
                    }
                    if (response.data.yearref !== null && response.data.yearref !== undefined) {
                        setDatalist(response.data.yearref)
                    } else {
                        setDatalist([])
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    });
                });
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-calendar-alt"></i> None Purchase</h4>
                                    <p className="mb-0">Manage all parameter of none purchase reference</p>
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                {
                                    props.permitdata !== undefined ?
                                        props.permitdata.user_role === "Admin" ?
                                            <button className="btn btn-warning btn-sm" onClick={() => {
                                                setMode('add')
                                                setDataitem({
                                                    datetimestamp: dayjs(new Date()).format('YYYY-MM-DD 00:00:00'),
                                                    year: 0,
                                                    site_code: 'P3-01',
                                                    none_purchase: 0,
                                                    none_purchase_approve: 0,
                                                    disable: false
                                                })
                                                setModal_item(true)
                                            }}><i className="fas fa-plus"></i> Add New</button>
                                            :
                                            null
                                        : null
                                }
                                <button className="btn btn-success btn-sm" onClick={() => { api_load() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <div className='d-flex'>
                            <div className="d-block ">
                                <label htmlFor="reporttype" className="form-label mb-0">Select Year Filter</label>
                                <Calendar
                                    allowClear={false}
                                    className={"form-control"}
                                    onChange={onCalendaraChange_Filter}
                                    picker={'year'}
                                    style={{
                                        fontFamily: "poppins",
                                        fontSize: "0.75rem",
                                        Color: "black",
                                        lineHeight: "1.5",
                                        cursor: "pointer",
                                    }}
                                    value={reportdate_filter}
                                />
                            </div>
                        </div>

                        <h5 className='mt-3'>None Purchase Table</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th>Year</th>
                                        <th>Site Name</th>
                                        <th>None Purchase Day</th>
                                        <th>None Purchase Day Approve</th>
                                        <th>Edit Time</th>
                                        {
                                            props.permitdata !== undefined ?
                                                props.permitdata.user_role === "Admin" ?
                                                    <th className="text-center action-fixwidth" style={{ width: "100px" }}>Action</th>
                                                    :
                                                    null
                                                : null
                                        }
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        datalist?.map((data, index) => (
                                            <tr key={data.datetimestamp}>
                                                <td><i className="fas fa-calendar-alt rows-icon"></i> {data.year}</td>
                                                <td>{data.site_code} {data.site_name}</td>
                                                <td>{data.none_purchase}</td>
                                                <td>{data.none_purchase_approve}</td>
                                                <td>{dayjs(new Date(data.edittime)).format('YYYY-MMM-DD HH:mm:ss')}</td>
                                                {
                                                    props.permitdata !== undefined ?
                                                        props.permitdata.user_role === "Admin" ?
                                                            <td>
                                                                <Link className="btn btn-icon btn-sm btn-warning btn-hover btn-bordered" title="Edit" onClick={() => {
                                                                    setMode('edit')
                                                                    setDataitem({
                                                                        datetimestamp: data.datetimestamp,
                                                                        year: data.year,
                                                                        site_code: data.site_code,
                                                                        site_name: data.site_name,
                                                                        none_purchase: data.none_purchase,
                                                                        none_purchase_approve: data.none_purchase_approve,
                                                                        disable: true
                                                                    })
                                                                    setModal_item(true)
                                                                }}><i className="fas fa-pen"></i></Link>
                                                            </td>
                                                            :
                                                            null
                                                        : null
                                                }
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>

                        </div>
                    </div>

                    <div className="modal meya-overide " style={{ display: modal_item ? "block" : "none" }}>
                        <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title"><i className="fas fa-calendar-alt"></i> {mode === "add" ? "Add" : "Edit"} None Purchase</h4>
                                    <i className="fe-x modal-close" onClick={() => { setModal_item(false) }}></i>
                                </div>
                                <div className="modal-body">
                                    <form ref={formRef} action="" method="POST" encType="multipart/form-data">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="year">Year (YYYY)</label>
                                                    <input type="text" className="form-control" name="year" value={dayjs(new Date(dataitem.datetimestamp)).format('YYYY')} required readOnly />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-8">
                                                <div className="form-group mb-3">
                                                    <div className="d-block">
                                                        <label htmlFor="reportsite" className="form-label mb-0">Site Name</label>
                                                        {mode === "edit" ?
                                                            <input type="text" className="form-control" name="reportsite" value={dataitem.site_code + " " + dataitem.site_name} required readOnly />
                                                            :
                                                            <select id="reportsite" name="reportsite" className="form-select font-sarabun" value={dataitem.site_code} readOnly onChange={(e) => {
                                                                setDataitem({
                                                                    ...dataitem,
                                                                    site_code: e.target.value
                                                                })
                                                            }} required>
                                                                {
                                                                    props.permitdata !== null ?
                                                                        props.permitdata.sitescope_arr.map((data, index) => (
                                                                            <option value={data.sitecode_txt} key={data.sitecode_txt}>{data.sitecode_txt} {data.sitename_th}</option>
                                                                        ))
                                                                        :
                                                                        null
                                                                }
                                                            </select>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="none_purchase">None Purchase Day</label>
                                                    <input type="number" className="form-control" name="none_purchase" min={0} max={365} step={1} value={dataitem.none_purchase} onChange={(e) => {
                                                        setDataitem({
                                                            ...dataitem,
                                                            none_purchase: e.target.value
                                                        })
                                                    }} required />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="none_purchase_approve">None Purchase Day Approve</label>
                                                    <input type="number" className="form-control" name="none_purchase_approve" min={0} max={365} step={1} value={dataitem.none_purchase_approve} onChange={(e) => {
                                                        setDataitem({
                                                            ...dataitem,
                                                            none_purchase_approve: e.target.value
                                                        })
                                                    }} required />
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-light btn-sm" type="button" onClick={() => { setModal_item(false) }}><i className="fe-x"></i> Cancel</button>
                                    <button className="btn btn-warning btn-sm" onClick={() => { { mode === "add" ? api_add() : api_edit() } }}><i className="fe-save"></i> Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminReferenceYear